﻿import $ from "jquery";
import "select2";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAktionPosition extends GuiDetailGeneric {

    constructor() {
        super("GuiDetailAktionPosition");

        $("select.tags").select2({
            tags: true,
            allowClear: true,
            placeholder: "",
            theme: "bootstrap-5",
            tokenSeparators: [",", " "]
        });
    }
}
